import { useCallback, useEffect } from "react";
import { useIsGoogleApiLoaded } from "../GoogleApiProvider";

type AutocompleteService = google.maps.places.AutocompleteService;
type AutocompletePrediction = google.maps.places.AutocompletePrediction;

let autocompleteService: AutocompleteService | null = null;

const MAX_RESULT_AMOUNT = 3;

export const useGoogleAutocomplete = () => {
  const { isLoaded } = useIsGoogleApiLoaded();

  useEffect(() => {
    if (isLoaded && !autocompleteService) {
      autocompleteService = new google.maps.places.AutocompleteService();
    }
  }, [isLoaded]);

  const fetchData = useCallback(async (searchValue: string): Promise<AutocompletePrediction[]> => {
    searchValue = searchValue.trim();
    if (!searchValue) {
      return [];
    }

    if (!autocompleteService) {
      console.warn(`Autocomplete service not loaded`);
      return [];
    }

    const results = await autocompleteService.getPlacePredictions({ input: searchValue, types: ["geocode"] });
    return (results?.predictions ?? []).slice(0, MAX_RESULT_AMOUNT);
  }, []);

  return { fetchData };
};
